/**
 * This file provides runtime environment variables from the runtime-config.js
 * file that was generated during build or from process.env during development.
 */

declare global {
  interface Window {
    __RUNTIME_CONFIG__?: {
      NEXT_PUBLIC_SUPABASE_URL?: string;
      NEXT_PUBLIC_SUPABASE_ANON_KEY?: string;
      NEXT_PUBLIC_SANITY_PROJECT_ID?: string;
      NEXT_PUBLIC_SANITY_DATASET?: string;
      NEXT_PUBLIC_DEPLOY_ENV?: string;
      SUPABASE_SERVICE_ROLE_KEY?: string;
    };
  }
}

/**
 * Gets all runtime configuration values
 */
export function getRuntimeConfig() {
  if (typeof window !== 'undefined' && window.__RUNTIME_CONFIG__) {
    return window.__RUNTIME_CONFIG__;
  }
  return {};
}

/**
 * Gets a runtime environment variable with fallback to Node.js process.env
 * 
 * This function allows us to seamlessly access environment variables in both
 * client and server contexts, and from runtime-config.js in production.
 */
export function getRuntimeVar(name: string): string {
  // In browser context, check for runtime config
  if (typeof window !== 'undefined' && window.__RUNTIME_CONFIG__) {
    const value = window.__RUNTIME_CONFIG__[name as keyof typeof window.__RUNTIME_CONFIG__];
    if (value) return value;
  }
  
  // Fall back to process.env (works in server context or during build)
  return (process.env as any)[name] || '';
}

/**
 * Create a placeholder runtime-config.js for development
 * This ensures the script referenced in layout.tsx doesn't cause 404 errors
 */
if (typeof window !== 'undefined' && process.env.NODE_ENV === 'development') {
  // Check if we need to create a dynamic runtime config script
  if (!window.__RUNTIME_CONFIG__) {
    // Create a script element to define the runtime config
    const script = document.createElement('script');
    script.textContent = `
      window.__RUNTIME_CONFIG__ = {
        NEXT_PUBLIC_SUPABASE_URL: "${process.env.NEXT_PUBLIC_SUPABASE_URL || ''}",
        NEXT_PUBLIC_SUPABASE_ANON_KEY: "${process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY || ''}",
        NEXT_PUBLIC_SANITY_PROJECT_ID: "${process.env.NEXT_PUBLIC_SANITY_PROJECT_ID || ''}",
        NEXT_PUBLIC_SANITY_DATASET: "${process.env.NEXT_PUBLIC_SANITY_DATASET || 'production'}",
        NEXT_PUBLIC_DEPLOY_ENV: "${process.env.NEXT_PUBLIC_DEPLOY_ENV || 'development'}"
      };
    `;
    document.head.appendChild(script);
  }
}